import { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import DataService from "./Service";
import { RouterPath } from "../../assets/dictionary/RouterPath"
import { useLocation } from "react-router-dom";

export const AdminRoute = ({ children }) => {
  const location = useLocation();
  const [isAdmin, setIsAdmin] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);


  useEffect(() => {
    DataService.getAuth()
      .then((response) => {
        setIsAdmin(response.is_superuser);
      })
      .catch((error) => {
        setIsAdmin(false);
        console.error("ERROR SET ADMIN:", error);
      })
      .finally(() => {
        setIsLoaded(true);
      });
  }, []);

  if (!isLoaded) {
    return null; // Add loader
  }

  if (!isAdmin) {
    return <Navigate to={RouterPath.CHAT} replace state={{ from: location }} />;
  }


  return children; // Si tout est bon, affiche le contenu protégé
};
